import React, { Fragment } from 'react';
import piramisLogo from '../../../assets/logo-piramis.png';

import { Nav, NavItem, NavLink } from 'reactstrap';

function Footer() {

  const year = new Date().getFullYear();
  const copyText = `Piramis Locator CRM \u00A9 ${year} by `;

  return (
    <Fragment>
      <div className="app-footer text-black-50 bg-ligh app-footer--shadow text-center">
        <div className="app-footer--first">
        </div>
        <div className="app-footer--second">
          <img src={piramisLogo} style={{ height: 21, width: "auto" }} /> {copyText}
          <a href="https://www.piramislocator.com" target="_blank">Piramis Locator</a>
        </div>
      </div>
    </Fragment>
  );
}

export default Footer;
